import userCluster from '../../assets/images/clsuters/user-cluster.svg';
import roleCluster from '../../assets/images/clsuters/role-cluster.svg';
import groupCluster from '../../assets/images/clsuters/group-cluster.svg';
import policyCluster from '../../assets/images/clsuters/policy-cluster.svg';
export const graphOptions = {
  interaction: {
    dragNodes: true,
    selectConnectedEdges: true,
    zoomView: true
  },
  height: '100%',
  layout: {
    randomSeed: 1,
    improvedLayout: false
  },
  physics: {
    enabled: true,
    maxVelocity: 50,
    barnesHut: {
      gravitationalConstant: -50000,
      // This is the default * 25.
      avoidOverlap: 1,
      springConstant: 0
    },
    stabilization: {
      enabled: false // This is here just to see what's going on from the very beginning.

    }
  },
  nodes: {
    borderWidth: 0,
    font: {
      size: 50
    },
    shapeProperties: {
      useBorderWithImage: true,
      interpolation: false
    },
    color: {
      border: '#FFFFFF',
      background: '#FFFFFF'
    }
  },
  edges: {
    arrows: {
      to: {
        enabled: false
      }
    },
    width: 1.5,
    font: {
      size: 0,
      align: 'top'
    },
    arrowStrikethrough: false,
    color: {
      color: '#808080'
    },
    // smooth:false,
    smooth: {
      type: 'straightCross'
    }
  }
};
export const userClusterOptions = {
  joinCondition: nodeOptions => {
    return nodeOptions.clusterId === 'userCluster';
  },
  clusterNodeProperties: {
    id: 'userCluster',
    borderWidth: 3,
    shape: 'circularImage',
    image: userCluster,
    level: 1,
    label: 'Users',
    size: 100
  },
  clusterEdgeProperties: {
    label: ''
  }
};
export const groupClusterOptions = {
  joinCondition: nodeOptions => {
    return nodeOptions.clusterId === 'groupCluster';
  },
  clusterNodeProperties: {
    id: 'groupCluster',
    borderWidth: 3,
    shape: 'circularImage',
    image: groupCluster,
    level: 3,
    label: 'Groups',
    size: 100
  },
  clusterEdgeProperties: {
    label: ''
  }
};
export const policyClusterOptions = {
  joinCondition: nodeOptions => {
    return nodeOptions.clusterId === 'policyCluster';
  },
  clusterNodeProperties: {
    id: 'policyCluster',
    borderWidth: 3,
    shape: 'circularImage',
    image: policyCluster,
    level: 4,
    label: 'Policies',
    size: 100
  },
  clusterEdgeProperties: {
    label: ''
  }
};
export const roleClusterOptions = {
  joinCondition: nodeOptions => {
    return nodeOptions.clusterId === 'roleCluster';
  },
  clusterNodeProperties: {
    id: 'roleCluster',
    borderWidth: 3,
    shape: 'circularImage',
    image: roleCluster,
    level: 4,
    label: 'Roles',
    size: 100
  },
  clusterEdgeProperties: {
    label: ''
  }
};